import React from "react";
import { FaSortUp, FaSortDown } from 'react-icons/fa';

const TableComponent = ({
    getTableProps,
    headerGroups,
    getTableBodyProps,
    rows,
    prepareRow,
    getRowClassName,
    getRowStyle,
}) => {

  if (rows.length === 0) {
    return (
        <div className="w-full min-w-[30rem] p-4 bg-white rounded-xl shadow-[0_4px_10px_rgba(0,0,0,0.03)] text-center">
            <p>No hay datos disponibles</p>
        </div>
    );
  }

    return (
        <div className="w-full min-w-0 overflow-x-auto p-4 bg-white rounded-xl shadow-[0_4px_10px_rgba(0,0,0,0.03)]">
          <table {...getTableProps()} className="min-w-full table-auto">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="px-3 text-start text-xs font-light uppercase cursor-pointer"
                      style={{ width: column.width }}
                      title="Ordenar por"
                    >
                      <div className="flex gap-2 items-center">
                        <div className="text-gray-600">
                          {column.render("Header")}
                        </div>
                        <div className="flex flex-col">
                          <FaSortUp
                            className={`text-sm translate-y-1/2 ${
                              column.isSorted && !column.isSortedDesc
                                ? "text-custom-green-ccard-3"
                                : "text-gray-300"
                            }`}
                          />
                          <FaSortDown
                            className={`text-sm -translate-y-1/2 ${
                              column.isSortedDesc
                                ? "text-custom-green-ccard-3"
                                : "text-gray-300"
                            }`}
                          />
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className={`hover:bg-gray-100 ${getRowClassName ? getRowClassName(row.original) : ""}`}
                    style={getRowStyle ? getRowStyle(row.original) : undefined}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td
                          {...cell.getCellProps()}
                          className="p-3 text-sm font-normal text-gray-700 first:rounded-l-lg last:rounded-r-lg"
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
};

export default TableComponent;
